import { render, staticRenderFns } from "./tankName.vue?vue&type=template&id=0376d6e6&"
import script from "./tankName.vue?vue&type=script&lang=js&"
export * from "./tankName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports